module.exports = __webpack_public_path__ + "static/media/star_border.05c89993.svg";